import { validateJsonResponse } from './APIUtils';

export const fetchGroups = channelId => {
  const url = '/api/qikserve/gfc2/brands?channelId=' + channelId;

  return fetch(url)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};

export const fetchGroup = groupName => {
  const url = `/api/qikserve/gfc2/brands/${groupName}`;

  return fetch(url)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};

export const createGroup = group => {
  const url = `/api/qikserve/gfc2/brands`;
  const request = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(group)
  };

  return fetch(url, request)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};

export const moveGroup = (brandId, targetChannelId) => {
  const url = `/api/qikserve/gfc2/brands/${brandId}/move`;
  const request = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ targetChannelId })
  };

  return fetch(url, request)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};

export const copyGroup = (
  brandId,
  targetChannelId,
  newName,
  copyContent = true
) => {
  const url = `/api/qikserve/gfc2/brands/${brandId}/copy`;
  const request = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ targetChannelId, newName, copyContent })
  };

  return fetch(url, request)
    .then(response => {
      return validateJsonResponse(response);
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      throw new Error(error);
    });
};
